import script from "./Hero.vue?vue&type=script&lang=ts&setup=true"
export * from "./Hero.vue?vue&type=script&lang=ts&setup=true"

import "./Hero.vue?vue&type=style&index=0&id=ac604bba&lang=scss"

const __exports__ = script;

export default __exports__